import React, { useState } from "react";
import { Modal, message } from "antd";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { refundAmountValidation } from "../../../utils/validations/formValidations";
import { CreateRefundRequest } from "../../../utils/api";

const ProcessManuallyRefundModal = ({
  refundDetails,
  setRefundDetails,
  tableRef,
}) => {
  const [loading, setLoading] = useState(false);
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({ resolver: yupResolver(refundAmountValidation) });

  const onSubmit = async (data) => {
    try {
      const payload = {
        ...data,
        serviceId: refundDetails?.data?.service?.id,
        bookingId: refundDetails?.data?.booking?.id,
        userId: refundDetails?.data?.user?.id,
        type: "auto",
        status: "approved",
      };
      setLoading(true);
      const response = await CreateRefundRequest(payload);
      if (response?.isSuccess) {
        setLoading(false);
        tableRef?.current?.onQueryChange();
        setRefundDetails({ visible: false, id: null });
        reset();
      } else {
        setLoading(false);
        message.error(response?.error || "Failed to refund manually");
      }
    } catch (error) {
      setLoading(false);
      message.error(error?.message);
    }
  };

  const handleFnCancel = () => {
    setRefundDetails({ visible: false, id: null });
    reset();
  };

  return (
    <Modal
      title="Enter Refund Amount"
      centered
      open={refundDetails?.visible}
      onCancel={
        loading
          ? undefined
          : () => setRefundDetails({ visible: false, id: null })
      }
      footer={null}
      width={430}
    >
      <form onSubmit={handleSubmit(onSubmit)} className="w-full space-y-4">
        <div className="w-full flex flex-col gap-x-4 mt-4">
          <div className="w-full border border-input-placeholder flex items-center gap-x-2 rounded-lg p-3 relative">
            <label
              className="absolute bg-white text-input-label -top-2 left-5 text-[11px] px-1"
              htmlFor="amount"
            >
              Amount
            </label>
            <input
              className="w-full outline-none text-[12px] text-input-placeholder"
              type="number"
              id="amount"
              {...register("amount")}
              placeholder="£0.00"
            />
          </div>
          <p className="text-[red] text-[12px]">{errors.amount?.message}</p>
        </div>

        <div className="flex gap-x-2 pt-3">
          <span
            className=" bg-white flex-1 text-center text-primary-700 border border-primary-700 text-[10px] px-6 py-3 rounded-lg cursor-pointer"
            onClick={handleFnCancel}
          >
            Cancel
          </span>
          <button
            disabled={loading}
            className="flex-1 text-center bg-primary-700 border border-primary-700 text-white text-[10px] px-6 py-3 rounded-lg cursor-pointer flex items-center justify-center gap-x-2"
          >
            Pay
            {loading && <span className="loader"></span>}
          </button>
        </div>
      </form>
    </Modal>
  );
};

export default ProcessManuallyRefundModal;
